import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import MobileNotifNav from 'apps/components/header/blocks/mobileNotifNav';
import { NotificationCenter } from 'apps/notificationCenter';

import { NotifCount } from 'apps/components/shared';
import {
  UserNavItem,
  UserNavButton,
} from 'apps/components/header/header.styled';

const HeaderNotifications = props => {
  const { show, isMobile, headerStore, notificationCenter } = props;
  const { pendingCount: notifCount } = notificationCenter;

  const onClickNotificationCenter = () => {
    headerStore?.ShowNotifDropdown();
    notificationCenter?.NewNotificationsQuery();
  };

  return (
    <UserNavItem>
      {notifCount > 0 && (
        <NotifCount isMobile={isMobile}>
          {notifCount > 99 ? `99+` : notifCount}
        </NotifCount>
      )}
      <UserNavButton
        outline
        variant='tertiary'
        ariaLabel='See Notifications'
        icon='notification'
        onClick={onClickNotificationCenter}
      />
      {isMobile ? (
        <MobileNotifNav
          show={show}
          title={<Trans>Notifications</Trans>}
          onClose={() => headerStore?.HideNotifDropdown()}
        />
      ) : (
        <NotificationCenter visible={show} />
      )}
    </UserNavItem>
  );
};

HeaderNotifications.defaultProps = {
  show: false,
  isMobile: false,
};

HeaderNotifications.propTypes = {
  show: PropTypes.bool,
  isMobile: PropTypes.bool,
  isDark: PropTypes.bool,
  headerStore: PropTypes.object,
  notificationCenter: PropTypes.object,
};

export default withNamespaces()(HeaderNotifications);
